import React, { Component } from 'react';
import LongText from '../Utils/LongText';


class Education extends Component {

    render() {
        const { activeButton } = this.props;
        return (
            <div style={{ all: 'unset' }}>
                {activeButton === 'about4' && (
                    <div className="about-right-section-page">
                        <h1>Education</h1>
                        <div className="about-right-section-text">
                            <LongText maxLength={300}>
                                <p>
                                    My concentration is on creative expression and
                                    transformation. I’m learning how we can approach the areas
                                    of creativity, intuition, and spiritual transformation in a
                                    rigorous manner, giving structure to concepts that can often
                                    be elusive and difficult to understand. I'm especially
                                    interested in observing how the unconscious operates and how
                                    intuition naturally guides us towards wholeness. Moral and
                                    ethical frameworks derived by these principles of wholeness
                                    can be used to design systems for change. I believe when an
                                    organization is designed with intentionality, respect, and
                                    reverence towards the creative process, it leads to a
                                    harmonious environment where people are free to
                                    authentically grow. I also am looking at how we can use
                                    creative expression at an individual level, as a therapeutic
                                    means of healing. My concentration provides the educational
                                    background necessary to apply for the Registered Expressive
                                    Arts Educator credential through the International
                                    Expressive Arts Therapy Association (IEATA). I plan on doing
                                    so soon after graduation.
                                </p>
                            </LongText>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default Education;